<template>

  <form-builder v-model="ptw" />

</template>

<script>

import FormBuilder from '@/components/atoms/forms/FormBuilder'
import draftPtw from '@/components/permits/draft-ptw.json'

export default {

  components: {
    FormBuilder
  },

  props: {

    siteId: {
      type: Number,
      required: true
    }

  },

  data () {
    return {
      ptw: {site_id: this.siteId,
        type: 'permit',
        formList: draftPtw
/*        formList: [
        { 'dataType': 'el-row', 'gutter': 12 },
        { 'dataType': 'el-col', 'span': 8 },
        { 'dataType': 'check-box', 'label': 'Medium Risk', 'required': true },
        { 'dataType': 'el-col', 'span': 8 },
        { 'dataType': 'check-box', 'label': 'High Risk', 'required': true },
        { 'dataType': 'el-col', 'span': 8 },
        { 'dataType': 'text-input', 'label': 'Purpose of Work', 'required': true },
        { 'dataType': 'el-row', 'gutter': 12 },
        { 'dataType': 'el-col', 'span': 12 },
        { 'dataType': 'date-input', 'label': 'Date', 'required': true },
        { 'dataType': 'el-col', 'span': 12 },
        { 'dataType': 'time-input', 'label': 'Time', 'required': true },
        { 'dataType': 'el-row', 'gutter': 12 },
        { 'dataType': 'el-col', 'span': 12 },
        { 'dataType': 'check-box', 'label': '1. Safety Induction - CIDB/NTMSP(Valid)', 'required': true },
        { 'dataType': 'el-col', 'span': 12 },
        { 'dataType': 'check-box', 'label': '2. Risk Assessment (HIRARC)', 'required': true },
        { 'dataType': 'el-col', 'span': 12 },
        { 'dataType': 'check-box', 'label': '3. Personal Protective Equipment (PPE)', 'required': true },
        { 'dataType': 'el-col', 'span': 12 },
        { 'dataType': 'check-box', 'label': '4. Valid WAH Certification', 'required': true },
        { 'dataType': 'el-col', 'span': 12 },
        { 'dataType': 'check-box', 'label': '5. Security Deposit (RM3000.00)', 'required': true },
        { 'dataType': 'h3', 'label': 'Compliance Warning', 'required': false },
        { 'dataType': 'text-area', 'label': 'The contractors assigned must provide <b>ONE</b> supervisor to supervise at sites until the task is completed and compliance to Dept of Occupational Safety and Health (DOSH) / Occupational Safety and Health Act 1994(OSHA) ,other Local Authority and relevant party requirements.A permit will not be issued until evidence has been demonstrated that the place of employment will be safe and healthful.The Division reserves the right to revoke or suspend a permit if it is unable to promptly verify compliance with the terms and conditions of the permit', 'disabled': true },
        { 'dataType': 'el-row', 'gutter': 12 },
        { 'dataType': 'el-col', 'span': 8 },
        { 'dataType': 'file-upload', 'label': 'Deposit', 'required': true }
      ]
*/
    }
    }
  }
}
</script>

<style scoped lang="scss">
/* @import './assets/css/vueformulate/snow.scss' ; */
</style>
